"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _mobx = require("mobx");
var _constants = require("../constants");
var _bookings = _interopRequireDefault(require("./bookings.store"));
var _retrieveOrder = _interopRequireDefault(require("./retrieve-order.store"));
var _retrieveSale = _interopRequireDefault(require("./retrieve-sale.store"));
var _bookingsTjwl = _interopRequireDefault(require("./bookings.tjwl.store"));
var _user = _interopRequireDefault(require("./user.store"));
var _order = require("../factories/order.factory");
var _bookings2 = require("../utils/bookings.utils");
var _class;
//
/**
 * booking page store
 */
//
let BookingPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function BookingPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, BookingPageStore);
    this.$env = $env;
    this.bookingsStore = new _bookings.default(initialState.bookingsStore);
    this.bookingsTjwlStore = new _bookingsTjwl.default(initialState.bookingsStore);
    this.userStore = new _user.default(initialState.userStore);
    this.retrieveOrderStore = new _retrieveOrder.default(initialState.retrieveOrderStore, this.$env);
    this.retrieveSaleStore = new _retrieveSale.default(initialState.retrieveSaleStore, this.$env);
  }

  /**
   * get bookings
   * @return {Array} orders
   */
  (0, _createClass2.default)(BookingPageStore, [{
    key: "bookings",
    get: function () {
      return this.bookingsStore.orders.map(order => {
        return {
          ...(0, _order.orderFactory)(order, this.$env.currency.formatPrice, this.$env.config.language),
          isTajawal: 0
        };
      });
    }

    /**
     * get tajawal bookings
     * @return {Array} orders
     */
  }, {
    key: "tjwlBookings",
    get: function () {
      return this.bookingsTjwlStore.orders.map(order => {
        return {
          ...(0, _order.orderFactory)(order, this.$env.currency.formatPrice, this.$env.config.language),
          isTajawal: 1
        };
      });
    }

    /**
     * get tajwal upcoming bookings
     * @returns {Array}
     */
  }, {
    key: "tjwlUpcomingBookings",
    get: function () {
      return (0, _orderBy2.default)((0, _filter2.default)(this.tjwlBookings, {
        bookingType: _constants.BOOKING_TYPES.UPCOMING
      }), ['isPayLater', 'dayDiffFromCurrentDate'], ['desc', 'asc']);
    }

    /**
     * get upcoming bookings
     * @returns {Array}
     */
  }, {
    key: "upcomingBookings",
    get: function () {
      return (0, _orderBy2.default)((0, _filter2.default)(this.bookings, {
        bookingType: _constants.BOOKING_TYPES.UPCOMING
      }), ['isPayLater', 'dayDiffFromCurrentDate', 'dayDiffFromDepartureDate'], ['desc', 'asc', 'asc']);
    }

    /**
     * get upcoming pending bookings
     * @returns {Array}
     */
  }, {
    key: "upcomingPendingBookings",
    get: function () {
      return (0, _filter2.default)(this.upcomingBookings, booking => !(0, _includes2.default)([_constants.OLD_BOOKING_STATUS.FAILURE, _constants.FLIGHT_BOOKING_STATUS.FAILURE, _constants.ACCOMMODATION_BOOKING_STATUS.FAILURE], booking.bookingStatus) && booking.isPayLater);
    }

    /**
     * get tajawal upcoming pending bookings
     * @returns {Array}
     */
  }, {
    key: "tjwlUpcomingPendingBookings",
    get: function () {
      return (0, _filter2.default)(this.tjwlUpcomingBookings, booking => !(0, _includes2.default)([_constants.OLD_BOOKING_STATUS.FAILURE, _constants.FLIGHT_BOOKING_STATUS.FAILURE], booking.bookingStatus) && booking.isPayLater);
    }

    /**
     * get upcoming confirmed bookings
     * @returns {Array}
     */
  }, {
    key: "upcomingConfirmedBookings",
    get: function () {
      return (0, _filter2.default)(this.upcomingBookings, booking => !(0, _includes2.default)([_constants.OLD_BOOKING_STATUS.FAILURE, _constants.FLIGHT_BOOKING_STATUS.FAILURE, _constants.ACCOMMODATION_BOOKING_STATUS.FAILURE], booking.bookingStatus) && !booking.isPayLater);
    }

    /**
     * get tajawal upcoming confirmed bookings
     * @returns {Array}
     */
  }, {
    key: "tjwlUpcomingConfirmedBookings",
    get: function () {
      return (0, _filter2.default)(this.tjwlUpcomingBookings, booking => !(0, _includes2.default)([_constants.OLD_BOOKING_STATUS.FAILURE, _constants.FLIGHT_BOOKING_STATUS.FAILURE], booking.bookingStatus) && !booking.isPayLater);
    }

    /**
     * get upcoming failed bookings
     * @returns {Array}
     */
  }, {
    key: "upcomingFailedBookings",
    get: function () {
      return (0, _filter2.default)(this.upcomingBookings, booking => (0, _includes2.default)([_constants.OLD_BOOKING_STATUS.FAILURE, _constants.FLIGHT_BOOKING_STATUS.FAILURE, _constants.ACCOMMODATION_BOOKING_STATUS.FAILURE], booking.bookingStatus));
    }

    /**
     * get tajawal upcoming failed bookings
     * @returns {Array}
     */
  }, {
    key: "tjwlUpcomingFailedBookings",
    get: function () {
      return (0, _filter2.default)(this.tjwlUpcomingBookings, booking => (0, _includes2.default)([_constants.OLD_BOOKING_STATUS.FAILURE, _constants.FLIGHT_BOOKING_STATUS.FAILURE], booking.bookingStatus));
    }

    /**
     * get past bookings
     * @returns {Array}
     */
  }, {
    key: "pastBookings",
    get: function () {
      return (0, _orderBy2.default)((0, _filter2.default)(this.bookings, {
        bookingType: _constants.BOOKING_TYPES.PAST
      }), ['dayDiffFromCurrentDate', 'dayDiffFromDepartureDate'], ['desc', 'desc']);
    }

    /**
     * get past tajwal bookings
     * @returns {Array}
     */
  }, {
    key: "tjwlPastBookings",
    get: function () {
      return (0, _orderBy2.default)((0, _filter2.default)(this.tjwlBookings, {
        bookingType: _constants.BOOKING_TYPES.PAST
      }), ['dayDiffFromCurrentDate'], ['desc']);
    }
  }, {
    key: "sortedBookings",
    get: function () {
      const sortedListBookings = (0, _bookings2.sortedBookings)(this.upcomingBookings);
      return sortedListBookings;
    }
  }, {
    key: "pastSortedBookings",
    get: function () {
      const sortedListBookings = (0, _bookings2.sortedPastBookings)(this.pastBookings);
      return sortedListBookings;
    }
  }]);
  return BookingPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "bookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "bookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "tjwlBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tjwlBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "tjwlUpcomingBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tjwlUpcomingBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "upcomingBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "upcomingBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "upcomingPendingBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "upcomingPendingBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "tjwlUpcomingPendingBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tjwlUpcomingPendingBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "upcomingConfirmedBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "upcomingConfirmedBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "tjwlUpcomingConfirmedBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tjwlUpcomingConfirmedBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "upcomingFailedBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "upcomingFailedBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "tjwlUpcomingFailedBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tjwlUpcomingFailedBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pastBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pastBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "tjwlPastBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tjwlPastBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "sortedBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedBookings"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pastSortedBookings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pastSortedBookings"), _class.prototype)), _class);
exports.default = BookingPageStore;